/**
 * 自动生成， 请不要手工修改！
 */

import { JsonTypeTagType } from "../../../serialize/JsonTypeTagType";
import { OrderFilter } from "./OrderFilter";
import { QuerySpec } from "../../query/QuerySpec";
import { TypeFactory } from "../../../serialize/TypeFactory";

export class OrderQuerySpec extends QuerySpec<OrderFilter> {
  constructor() {
    super();
  }

  public fillFromJson(json: Object, factory?: TypeFactory) {
    if (factory) {
      super.fillFromJson(json, factory);
    } else {
      super.fillFromJson(json);
    }
  }

  public fillToJson(json: Object, includeTypeTag = true) {
    super.fillToJson(json, includeTypeTag);

    if (includeTypeTag) {
      json["__type"] = "OrderQuerySpec";
    }
  }

  public getTypeId(): string {
    return "OrderQuerySpec";
  }

  public getClassName(): string {
    return "com.gong_wei.common.datatype.business.order.OrderQuerySpec";
  }
}
